import { render, staticRenderFns } from "./TagsRoute.vue?vue&type=template&id=6573c773&"
import script from "./TagsRoute.vue?vue&type=script&lang=js&"
export * from "./TagsRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../.yarn/$$virtual/vue-loader-virtual-2fffd51942/0/cache/vue-loader-npm-15.9.3-4ca89c7e4b-bc7d4c63e0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports